<template>
  <div>
    <div class="toolbar">
      <div>
        <h2>小分类管理</h2>
        <p class="hint">每个大分类下最多 {{ maxCount }} 个小分类（4×4 + 独立返回行）</p>
      </div>
      <el-button type="primary" @click="openForm()">新增</el-button>
    </div>
    <div class="filters">
      <el-input
        v-model="keyword"
        placeholder="搜索名称（中/缅）"
        clearable
        prefix-icon="el-icon-search"
        class="filter-input"
      />
      <el-select
        v-model="filterCityId"
        placeholder="城市"
        class="filter-select"
        @change="onCityFilterChange"
      >
        <el-option label="全部" value="all" />
        <el-option label="待分配" :value="0" />
        <el-option v-for="c in cities" :key="c.id" :label="c.name_zh" :value="c.id" />
      </el-select>
      <el-select
        v-model="filterMainId"
        placeholder="大分类"
        class="filter-select"
      >
        <el-option label="全部" value="all" />
        <el-option label="待分配" :value="0" />
        <el-option v-for="m in filteredMains" :key="m.id" :label="m.name_zh" :value="m.id" />
      </el-select>
      <el-radio-group v-model="sortAsc" size="small">
        <el-radio-button :label="true">正序</el-radio-button>
        <el-radio-button :label="false">倒序</el-radio-button>
      </el-radio-group>
    </div>
    <div v-if="!isMobile" class="table-scroll">
    <el-table :data="displayList" v-loading="loading" border>
      <el-table-column prop="id" label="ID" width="70" />
      <el-table-column label="城市" width="100">
        <template slot-scope="{ row }">
          <span v-if="row.city_name_zh">{{ row.city_name_zh }}</span>
          <el-tag v-else type="warning" size="mini">待分配</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="name_zh" label="中文名" />
      <el-table-column prop="name_my" label="缅文名" />
      <el-table-column label="所属大分类">
        <template slot-scope="{ row }">
          <span v-if="row.main_name_zh">{{ row.main_name_zh }}</span>
          <el-tag v-else type="warning" size="mini">待分配</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="sort_order" label="排序" width="80" />
      <el-table-column prop="top_rank" label="TOP排名" width="90">
        <template slot-scope="{ row }">{{ row.top_rank ?? '-' }}</template>
      </el-table-column>
      <el-table-column label="展示" width="80">
        <template slot-scope="{ row }">
          <el-tag :type="row.is_active ? 'success' : 'info'" size="mini">
            {{ row.is_active ? '是' : '否' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="220">
        <template slot-scope="{ row }">
          <el-button type="text" @click="openAssign(row)">分配</el-button>
          <el-button type="text" @click="openForm(row)">编辑</el-button>
          <el-button type="text" style="color:#f56c6c" @click="onDelete(row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    </div>

    <MobileCardList
      v-if="isMobile"
      :data="displayList"
      :loading="loading"
      :fields="cardFields"
    >
      <template #main_name_zh="{ row }">
        <span v-if="row.main_name_zh">{{ row.main_name_zh }}</span>
        <el-tag v-else type="warning" size="mini">待分配</el-tag>
      </template>
      <template #is_active="{ row }">
        <el-tag :type="row.is_active ? 'success' : 'info'" size="mini">
          {{ row.is_active ? '是' : '否' }}
        </el-tag>
      </template>
      <template #actions="{ row }">
        <el-button type="text" @click="openAssign(row)">分配</el-button>
        <el-button type="text" @click="openForm(row)">编辑</el-button>
        <el-button type="text" style="color:#f56c6c" @click="onDelete(row)">删除</el-button>
      </template>
    </MobileCardList>

    <el-dialog :title="form.id ? '编辑小分类' : '新增小分类'" :visible.sync="visible" width="480px">
      <el-form :model="form" label-width="100px">
        <el-form-item label="所属大分类">
          <el-select
            v-model="form.main_category_id"
            clearable
            placeholder="留空=待分配"
            style="width:100%"
            @change="onFormMainChange"
          >
            <el-option v-for="m in formMains" :key="m.id" :label="mainOptionLabel(m)" :value="m.id" />
          </el-select>
          <p class="form-hint">城市跟随大分类，无需单独选择</p>
        </el-form-item>
        <el-form-item label="中文名"><el-input v-model="form.name_zh" /></el-form-item>
        <el-form-item label="缅文名"><el-input v-model="form.name_my" /></el-form-item>
        <el-form-item label="排序"><el-input-number v-model="form.sort_order" :min="1" /></el-form-item>
        <el-form-item label="TOP排名">
          <div class="top-rank-row">
            <template v-if="form.top_rank != null">
              <el-input-number v-model="form.top_rank" :min="1" :max="maxTopRank" :controls="true" />
              <el-button type="text" class="top-rank-clear" @click="clearTopRank">清除排名</el-button>
            </template>
            <el-button
              v-else
              type="text"
              :disabled="!canSetTopRank"
              @click="form.top_rank = suggestTopRank()"
            >设置 TOP 排名</el-button>
          </div>
          <p class="form-hint">TOP 榜最多 {{ maxTopRank }} 个（2 行 × 3 列），数字越小越靠前；清除后不参与 TOP 榜</p>
        </el-form-item>
        <el-form-item label="展示"><el-switch v-model="form.is_active" :active-value="1" :inactive-value="0" /></el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="visible = false">取消</el-button>
        <el-button type="primary" @click="onSubmit">确定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="分配大分类" :visible.sync="assignVisible" width="400px">
      <el-form label-width="80px">
        <el-form-item label="城市">
          <el-select
            v-model="assignCityId"
            placeholder="选择城市"
            style="width:100%"
            @change="onAssignCityChange"
          >
            <el-option label="待分配" :value="0" />
            <el-option v-for="c in cities" :key="c.id" :label="c.name_zh" :value="c.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="大分类">
          <el-select
            v-model="assignMainId"
            placeholder="选择大分类"
            style="width:100%"
            :disabled="assignCityId === null"
          >
            <el-option
              v-for="m in assignMains"
              :key="m.id"
              :label="m.name_zh"
              :value="m.id"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="assignVisible = false">取消</el-button>
        <el-button type="primary" :disabled="!canAssign" @click="onAssign">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { api } from '../api';
import { calcNextSortOrder, filterByKeyword, sortByOrder, MAX_SUB_CATEGORY_KEYBOARD, MAX_TOP_RANK } from '../utils/listHelpers';
import responsiveMixin from '../mixins/responsive';

const emptyForm = () => ({
  id: null, main_category_id: null, name_zh: '', name_my: '', sort_order: 1, top_rank: null, is_active: 1,
});

export default {
  name: 'SubCategory',
  mixins: [responsiveMixin],
  data() {
    return {
      list: [],
      mains: [],
      cities: [],
      loading: false,
      visible: false,
      form: emptyForm(),
      assignVisible: false,
      assignRow: null,
      assignCityId: null,
      assignMainId: null,
      keyword: '',
      filterCityId: 'all',
      filterMainId: 'all',
      sortAsc: true,
      cardFields: [
        { label: 'ID', prop: 'id' },
        { label: '城市', prop: 'city_name_zh' },
        { label: '中文名', prop: 'name_zh' },
        { label: '缅文名', prop: 'name_my' },
        { label: '所属大分类', prop: 'main_name_zh' },
        { label: '排序', prop: 'sort_order' },
        { label: 'TOP排名', prop: 'top_rank' },
        { label: '展示', prop: 'is_active' },
      ],
    };
  },
  computed: {
    maxCount() {
      return MAX_SUB_CATEGORY_KEYBOARD;
    },
    maxTopRank() {
      return MAX_TOP_RANK;
    },
    topRankedCount() {
      const cityId = this.formCityId;
      if (!cityId) return 0;
      return this.list.filter(
        (i) => i.top_rank != null && i.id !== this.form.id && i.city_id === cityId
      ).length;
    },
    canSetTopRank() {
      return this.form.top_rank != null || this.topRankedCount < MAX_TOP_RANK;
    },
    filteredMains() {
      if (this.filterCityId === 'all') return this.mains;
      if (this.filterCityId === 0) return this.mains.filter((m) => !m.city_id);
      return this.mains.filter((m) => m.city_id === this.filterCityId);
    },
    formMains() {
      return this.mains;
    },
    formCityId() {
      if (!this.form.main_category_id) return null;
      const main = this.mains.find((m) => m.id === this.form.main_category_id);
      return main?.city_id ?? null;
    },
    assignMains() {
      if (this.assignCityId === null) return [];
      if (this.assignCityId === 0) return this.mains.filter((m) => !m.city_id);
      return this.mains.filter((m) => m.city_id === this.assignCityId);
    },
    canAssign() {
      return this.assignCityId !== null && Boolean(this.assignMainId);
    },
    displayList() {
      let items = filterByKeyword(this.list, this.keyword);
      if (this.filterMainId === 0) {
        items = items.filter((i) => !i.main_category_id);
      } else if (this.filterMainId !== 'all') {
        items = items.filter((i) => i.main_category_id === this.filterMainId);
      }
      return sortByOrder(items, this.sortAsc);
    },
  },
  created() {
    this.loadCities();
    this.load();
    this.loadMains();
  },
  methods: {
    onCityFilterChange() {
      this.filterMainId = 'all';
      this.load();
    },
    countSubsUnderMain(mainId, excludeId = 0) {
      if (!mainId) return 0;
      return this.list.filter(
        (i) => i.main_category_id === mainId && i.id !== excludeId
      ).length;
    },
    subLimitMessage(mainId) {
      return `该大分类下小分类最多 ${MAX_SUB_CATEGORY_KEYBOARD} 个`;
    },
    assertSubLimit(mainId, excludeId = 0) {
      if (!mainId) return true;
      return this.countSubsUnderMain(mainId, excludeId) < MAX_SUB_CATEGORY_KEYBOARD;
    },
    async loadCities() {
      try {
        const { data } = await api.cities.list();
        this.cities = data;
      } catch (e) {
        this.$message.error(e.message);
      }
    },
    async loadMains() {
      try {
        const { data } = await api.mainCategories.list();
        this.mains = data;
      } catch (e) {
        this.$message.error(e.message);
      }
    },
    async load() {
      this.loading = true;
      try {
        const params = {};
        if (this.filterCityId === 0) params.city_id = 0;
        else if (this.filterCityId !== 'all') params.city_id = this.filterCityId;
        const { data } = await api.subCategories.list(params);
        this.list = data;
      } catch (e) {
        this.$message.error(e.message);
      } finally {
        this.loading = false;
      }
    },
    suggestSortOrder(mainId) {
      return calcNextSortOrder(this.list, 'main_category_id', mainId ?? null);
    },
    onFormMainChange(mainId) {
      if (!this.form.id) {
        this.form.sort_order = this.suggestSortOrder(mainId);
      }
      if (!this.formCityId) {
        this.form.top_rank = null;
      }
    },
    mainOptionLabel(m) {
      const city = m.city_name_zh || '待分配';
      return `${m.name_zh}（${city}）`;
    },
    clearTopRank() {
      this.form.top_rank = null;
    },
    suggestTopRank() {
      const cityId = this.formCityId;
      const used = new Set(
        this.list
          .filter((i) => i.top_rank != null && i.id !== this.form.id && i.city_id === cityId)
          .map((i) => i.top_rank)
      );
      for (let r = 1; r <= MAX_TOP_RANK; r += 1) {
        if (!used.has(r)) return r;
      }
      return MAX_TOP_RANK;
    },
    openForm(row) {
      if (row) {
        this.form = {
          ...row,
          main_category_id: row.main_category_id || null,
          top_rank: row.top_rank ?? null,
        };
      } else {
        this.form = {
          ...emptyForm(),
          sort_order: this.suggestSortOrder(null),
        };
      }
      this.visible = true;
    },
    openAssign(row) {
      this.assignRow = row;
      const mainId = row.main_category_id || null;
      let cityId = null;
      if (mainId) {
        const main = this.mains.find((m) => m.id === mainId);
        cityId = main?.city_id ?? 0;
      }
      this.assignCityId = cityId;
      this.assignMainId = mainId;
      this.assignVisible = true;
    },
    onAssignCityChange() {
      if (!this.assignMains.some((m) => m.id === this.assignMainId)) {
        this.assignMainId = null;
      }
    },
    onSubmit() {
      const mainId = this.form.main_category_id || null;
      if (!this.assertSubLimit(mainId, this.form.id || 0)) {
        this.$message.warning(this.subLimitMessage(mainId));
        return;
      }
      const topRank = this.form.top_rank > 0 ? this.form.top_rank : null;
      if (topRank != null) {
        if (topRank > MAX_TOP_RANK) {
          this.$message.warning(`TOP排名只能是 1-${MAX_TOP_RANK}`);
          return;
        }
        const hadRank = Boolean(this.form.id && this.list.find((i) => i.id === this.form.id)?.top_rank != null);
        if (!hadRank && this.topRankedCount >= MAX_TOP_RANK) {
          this.$message.warning(`TOP榜已满，最多 ${MAX_TOP_RANK} 个小分类`);
          return;
        }
      }
      const action = this.form.id ? '保存修改' : '新增';
      this.$confirm(`确认${action}该小分类？`, '提示', { type: 'warning' })
        .then(async () => {
          try {
            const payload = {
              ...this.form,
              main_category_id: this.form.main_category_id || null,
              top_rank: topRank,
            };
            if (this.form.id) {
              await api.subCategories.update(this.form.id, payload);
            } else {
              await api.subCategories.create(payload);
            }
            this.$message.success('操作成功');
            this.visible = false;
            this.load();
          } catch (e) {
            this.$message.error(e.message);
          }
        })
        .catch(() => {});
    },
    onAssign() {
      if (this.assignCityId === null) {
        this.$message.warning('请选择城市');
        return;
      }
      if (!this.assignMainId) {
        this.$message.warning('请选择大分类');
        return;
      }
      const mainId = this.assignMainId;
      if (!this.assertSubLimit(mainId, this.assignRow.id)) {
        this.$message.warning(this.subLimitMessage(mainId));
        return;
      }
      const main = this.mains.find((m) => m.id === mainId);
      const cityLabel = this.assignCityId === 0
        ? '待分配'
        : (this.cities.find((c) => c.id === this.assignCityId)?.name_zh || '');
      const mainName = main?.name_zh || '';
      this.$confirm(
        `确认将小分类「${this.assignRow.name_zh}」分配到「${cityLabel} · ${mainName}」？`,
        '分配确认',
        { type: 'warning' },
      )
        .then(async () => {
          try {
            await api.subCategories.assign(this.assignRow.id, mainId);
            this.$message.success('分配成功');
            this.assignVisible = false;
            this.load();
          } catch (e) {
            this.$message.error(e.message);
          }
        })
        .catch(() => {});
    },
    onDelete(row) {
      this.$confirm(`确认删除小分类「${row.name_zh}」？（逻辑删除，其下商家将变为待分类）`, '删除确认', {
        type: 'warning',
        confirmButtonText: '确认删除',
        confirmButtonClass: 'el-button--danger',
      })
        .then(async () => {
          try {
            await api.subCategories.remove(row.id);
            this.$message.success('已删除');
            this.load();
          } catch (e) {
            this.$message.error(e.message);
          }
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped>
.toolbar { display: flex; justify-content: space-between; align-items: center; margin-bottom: 16px; }
.toolbar h2 { margin: 0; }
.hint { margin: 4px 0 0; font-size: 13px; color: #909399; }
.filters { display: flex; align-items: center; gap: 12px; margin-bottom: 16px; flex-wrap: wrap; }
.filter-input { width: 220px; }
.filter-select { width: 180px; }
.form-hint { margin: 4px 0 0; font-size: 12px; color: #909399; }
.top-rank-row { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; }
.top-rank-clear { color: #f56c6c; padding: 0; }
</style>
